import type { Translations } from "../types";

const pt: Translations = {
  nav: {
    features: "Funcionalidades",
    pricing: "Preços",
    blog: "Blog",
    freeTools: "Ferramentas Grátis",
    contact: "Contato",
    startFree: "Começar Grátis",
    solutions: "Soluções",
    useCases: "Casos de Uso",
    switchToDark: "Mudar para Modo Escuro",
    switchToLight: "Mudar para Modo Claro",
    solutionsToolsDesc: "Calculadoras, geradores e mais",
    solutionsUseCasesDesc: "Veja o Zapify em ação",
  },
  hero: {
    rotatingWords: ["DMs Auto", "Respostas IA"],
    headline: "Responda aos comentários do Instagram com",
    subheadline:
      "Responda automaticamente aos comentários com DMs personalizados. Capture leads e cresça seu público no piloto automático.",
    cta: "Começar Gratuitamente",
    helperText: "Grátis para começar",
    helperSeparator: "Configuração fácil",
    trustedBy: "A confiança de",
    creators: "5.000+ criadores",
    dmsSent: "DMs Enviados",
    dmsCount: "1.000.000+",
  },
  features: {
    headingTitle: "Tudo o que Você Precisa para",
    headingHighlight: "Escalar seu",
    headingDescription:
      "Zapify dá controle total sobre seu assistente de IA e automação, economizando horas de trabalho manual.",
    cta: "Ativar 30 Dias de Teste Grátis",
    items: [
      {
        title: "Automação de DMs",
        description:
          "Responda automaticamente a cada comentário do Instagram por DM. Transforme o caos dos DMs em leads qualificados e vendas.",
      },
      {
        title: "Pedir para Seguir",
        description:
          "Antes de compartilhar seu conteúdo exclusivo, pedimos ao usuário que siga você.",
      },
      {
        title: "Respostas com IA",
        description:
          "Respostas que entendem o comentário e soam como você.",
      },
      {
        title: "Voz Totalmente Personalizável",
        description:
          "Escolha tom e estilo, respostas curtas/longas, e controle emojis + #hashtags.",
      },
      {
        title: "Suporte Global a Idiomas",
        description: "Fale o idioma deles, automaticamente.",
      },
      {
        title: "Coletar E-mails",
        description:
          "Construa sua lista de e-mails automaticamente a partir dos comentários do Instagram.",
      },
      {
        title: "Acesso da Equipe",
        description:
          "Convide membros da equipe para gerenciar respostas, leads e conversas juntos.",
      },
      {
        title: "Múltiplas Contas do Instagram",
        description:
          "Conecte e gerencie múltiplas contas do Instagram a partir de um único painel.",
      },
    ],
  },
  process: {
    headingTitle: "Comece a Automatizar em",
    headingHighlight: "Minutos",
    headingDescription:
      "Siga estes passos simples para automatizar seus DMs",
    step: "Passo",
    cta: "Iniciar Automação",
    steps: [
      {
        title: "Selecionar Gatilhos",
        description:
          "Escolha quais posts e palavras-chave ativam sua automação.",
      },
      {
        title: "Automatizar Resposta",
        description:
          "Crie mensagens personalizadas com links, ofertas ou conteúdo para enviar automaticamente.",
      },
      {
        title: "Viral",
        description:
          "Crie mais. Gerencie menos. A automação faz o resto.",
      },
    ],
  },
  engagement: {
    headingTitle: "Transforme o Engajamento do Instagram em",
    headingHighlight: "Receita no Piloto Automático",
    headingDescription:
      "Converta cada comentário em oportunidades de venda. Ganhe dinheiro 24/7 enquanto seu assistente de IA cuida das conversas",
    card1Title: "Aumente os Cliques em Links",
    card1TitleLine2: "Conversões",
    card1Description:
      "Transforme comentários em tráfego direto. Entregue automaticamente suas ofertas, produtos e conteúdo diretamente aos compradores interessados por DMs.",
    card2Title: "Agente de Vendas IA 24/7",
    card2Description:
      "Nunca perca um comentário. Responda instantaneamente e converta conversas em vendas 24/7 enquanto você dorme.",
  },
  graph: {
    headingHighlight: "Impulsione seu",
    headingHighlightWord: "Alcance",
    headingDescription:
      "Veja como DMs automatizados e respostas de IA disparam sua taxa de engajamento, crescimento de seguidores e conversões de vendas em até 10x",
    title: "Aumente o Engajamento",
    by10x: "em 10x",
    subtitle: "Monetize seu público enquanto você dorme",
    description:
      "Responda a cada comentário, converta-os em DMs e aumente o engajamento automaticamente.",
    afterZapify: "Depois do Zapify Pro",
    cta: "Aumente o Engajamento Agora",
  },
  testimonials: {
    headingTitle: "Veja Por Que os Criadores do Instagram",
    headingHighlight: "Amam",
    headingDescription:
      "Histórias de sucesso reais de influenciadores e marcas que transformaram seu engajamento e receita no Instagram com automação de IA",
    followers: "Seguidores",
  },
  faq: {
    headingTitle: "Perguntas",
    headingHighlight: "Frequentes",
    headingDescription:
      "Tudo o que você precisa saber para começar com o Zapify",
    items: [
      {
        question: "O Zapify funciona com qualquer conta do Instagram?",
        answer:
          "O Zapify suporta contas profissionais do Instagram (Business ou Creator). Contas pessoais não são suportadas pela API.",
      },
      {
        question: "O Zapify é acessível no celular?",
        answer:
          "Sim, o Zapify funciona muito bem no seu navegador móvel, você pode instalar o App do navegador daqui.",
      },
      {
        question: "As automações vão soar robóticas?",
        answer:
          "Não. O Zapify suporta controles de voz da marca (tom, comprimento, uso de emojis) para que as respostas de IA correspondam ao seu estilo. Você pode editar qualquer mensagem e adicionar uma transferência para atendente humano.",
      },
      {
        question: "O Zapify é aprovado pela Meta?",
        answer:
          "O Zapify é um Provedor de Tecnologia Verificado pela Meta, usamos as APIs oficiais do Instagram Graph. Seguimos os limites de taxa e as diretrizes de política para manter sua conta segura.",
      },
      {
        question: "O Zapify é seguro para usar?",
        answer:
          "Sim. Toda a autenticação usa OAuth seguro da Meta. Nunca pedimos sua senha do Instagram e respeitamos as permissões de API que você concede.",
      },
      {
        question: "O Zapify é gratuito?",
        answer:
          "Oferecemos um teste gratuito para que você possa testar as automações e ver os resultados antes de fazer upgrade.",
      },
      {
        question: "Vocês têm um programa de parceiros/afiliados?",
        answer:
          "Sim. Parceiros aprovados ganham comissões em novas inscrições e renovações. Inscreva-se na nossa página de Parceiros.",
      },
      {
        question: "Como entro em contato com o suporte?",
        answer:
          "Use o chat no app ou envie-nos um email — a maioria das perguntas recebe resposta no mesmo dia em dias úteis. Também fornecemos guias de configuração e modelos de melhores práticas.",
      },
    ],
  },
  verified: {
    headingTitle: "Programas",
    headingHighlight: "e Parceiros",
    headingDescription:
      "Nossa startup aceita pelo Stripe for Startups e Microsoft for Startups 2025",
    cta: "Ver Verificação",
    badge: "Verificado",
    heading: "Seu provedor de tecnologia verificado pela Meta",
    description: "Nossa empresa é oficialmente aceita no Microsoft Startups for Founders e Stripe Startup Program.",
    missionNote: "Veja: Início → seções herói e problemas dos criadores para nossa missão e nossos valores.",
    close: "Fechar",
  },
  // Stats
  stats: {
    dmsSent: "DMs Enviados",
    followersGained: "Seguidores Conquistados",
    commentsSent: "Comentários Enviados",
    countries: "Países",
  },

  // Pricing
  pricing: {
    headingTitle: "Escolha o plano que",
    headingHighlight: "atende às suas necessidades",
    headingDescription:
      "Preços flexíveis para cada criador — mude a qualquer momento e economize mais com cobrança anual",
    monthly: "Mensal",
    yearly: "Anual",
    get2MonthsFree: "Ganhe 2 Meses Grátis",
    freeTrial: "Teste Gratuito",
    freeTrialDesc: "Perfeito para começar com o Zapify.",
    starter: "Starter",
    starterDesc: "Ideal para criadores de conteúdo individuais.",
    professional: "Profissional",
    professionalDesc: "Ideal para startups e pequenas marcas.",
    subscribe: "Assinar",
    startFreeTrial: "Iniciar 30 Dias de Teste Grátis",
    free: "GRÁTIS",
    noCreditCard: "Sem Cartão de Crédito",
    bestSeller: "Mais Vendido",
    perMonth: "/mês",
    save: "Economize",
    unlimited: "Ilimitado",
    limited: "Limitado",
    email: "Email",
    priority: "Prioritário",
    automations: "Automações",
    dms: "DMs",
    aiReplies: "Respostas IA",
    askToFollow: "Pedir para Seguir",
    emailCollection: "Coleta de Emails",
    igProfile: "Perfil IG",
    teamAccess: "Acesso da Equipe",
    support: "Suporte",
    // Category headers
    automationPower: "Poder da Automação",
    aiCapabilities: "Capacidades de IA",
    leadGeneration: "Geração de Leads",
    analyticsTeam: "Análises & Equipe",
    supportPlatform: "Suporte & Plataforma",
    soonBadge: "Em breve",
    // AUTOMATION POWER features
    activeAutomations: "Automações ativas",
    instagramAccounts: "Contas Instagram",
    customTriggerWords: "Palavras de gatilho personalizadas",
    instantDMReplies: "Respostas DM instantâneas",
    commentToDMAutomation: "Automação comentário-para-DM",
    storyReplyAutomation: "Automação resposta a stories",
    welcomeMessageAutomation: "Automação mensagem de boas-vindas",
    smartGreetingMessage: "Mensagem de saudação inteligente",
    unlimitedPostsStories: "Posts e stories ilimitados automatizados",
    flexiblePostTargeting: "Segmentação flexível de posts (próximo, qualquer, múltiplos)",
    linkInDMCTAButtons: "Links no DM e botões CTA",
    followGatedDMsLinks: "DMs e links com follow",
    instagramSafetyLimits: "Limites de segurança do Instagram",
    customFlowBuilder: "Construtor de fluxos personalizados",
    // AI CAPABILITIES features
    aiCommentReplies: "Respostas a comentários IA / mês",
    aiPoweredInstantReplies: "Respostas instantâneas com IA",
    aiTrainedOnBrand: "IA treinada na sua marca",
    // LEAD GENERATION features
    storedContacts: "Contatos armazenados",
    emailCaptureInsideDMs: "Captura de email nos DMs",
    // ANALYTICS & TEAM features
    instagramInsights: "Insights do Instagram",
    monthlyPerformanceReports: "Relatórios de desempenho mensais",
    teamMembers: "Membros da equipe",
    // SUPPORT & PLATFORM features
    customerSupport: "Suporte ao cliente",
    languageSupport: "Suporte de idiomas",
    platformBranding: "Branding da plataforma",
    offerTitle: "Oferta por Tempo Limitado",
    offerDesc: "Cadastre-se hoje e ganhe",
    offerBadge: "10% DE DESCONTO HOJE",
    limitedSpots: "Vagas Limitadas",
    offerEndsIn: "A oferta termina em",
    days: "Dias",
    hours: "Horas",
    minutes: "Minutos",
    seconds: "Segundos",
    claimed: "reivindicado",
    secureCheckout: "Pagamento seguro",
    noCreditCardRequired: "Nenhum cartão de crédito necessário",
    copied: "COPIADO!",
    comparePlansEyebrow: "Sem enrolação",
    comparePlansTitle: "Decida antes da sua próxima Story sumir",
    comparePlansSubtitle:
      "Automações, DMs, IA, time - tudo numa tabela para você saber o que \"ilimitado\" realmente vale. Leia uma vez, escolha uma vez, pronto.",
    compareFeatureColumn: "Recurso",
    plansCtaBadgeLead: "Comece com inteligência.",
    plansCtaBadgeEmphasis: "Crie mais.",
    plansCtaTitleLead: "Não foi feito para te prender.",
    plansCtaTitleGradient: "Foi feito para te libertar.",
    plansCtaSubtitle:
      "Muitas ferramentas criam dependência. Nós o oposto: automatizar o que esgota, ficar onde importa e transformar conversas reais em impulso.",
    plansCtaSubtitleParagraph2:
      "Quando tudo fica tão quieto que você quase esquece a gente—foi isso que buscávamos.",
    plansCtaBullet1: "Sem cartão de crédito",
    plansCtaBullet3: "Cancele quando quiser, sem fidelidade longa",
    plansCtaTrust: "Mais de 5.000 criadores confiam em nós no mundo",
    signupMixEyebrow: "Instantâneo de cadastros",
    signupMixCountLabel: "cadastros nesta amostra",
    signupMixLeadTitle: "Como começaram",
    signupMixLeadSubtitle:
      "A maioria começa no teste gratuito. O restante se divide entre Starter e ir direto para o Professional.",
    signupMixLabelFreeTrial: "Teste gratuito",
    signupMixLabelStarter: "Starter",
    signupMixLabelProfessional: "Professional",
  },

  // CTA
  cta: {
    readyToTransform: "Pronto para Transformar seu Instagram?",
    joinThousands:
      "Junte-se a milhares de criadores e marcas que usam o Zapify para ganhar seguidores, aumentar o engajamento e economizar tempo.",
    startForFree: "Comece Grátis",
  },

  // Sticky
  sticky: {
    instantlyDm:
      "Envie DMs instantaneamente para quem comentar no seu Instagram",
    limitedOffer: "Oferta por Tempo Limitado - 10% DE DESCONTO",
    endsIn: "Termina em",
    getStartedFree: "Comece Grátis",
    start: "Começar",
  },

  // Contact Page
  contactPage: {
    heading: "Contatar Suporte",
    subtitle:
      "Estamos aqui para ajudar você a crescer. Entre em contato para qualquer dúvida ou suporte.",
    connectWithUs: "Fale Conosco",
    connectDescription: "Escolha sua forma preferida de entrar em contato",
    emailUs: "Envie um e-mail",
    emailResponse: "Responderemos em 24 horas",
    support: "Suporte",
    getInstantHelp: "Obtenha ajuda instantânea em",
    scheduleMeet: "Agendar Reunião",
    followUs: "Siga-nos",
    stayUpdated: "Fique por dentro das últimas novidades",
    responseTime: "Resposta em 24h",
  },

  // Contact Form
  contactForm: {
    heading: "Envie-nos uma mensagem",
    description: "Preencha o formulário abaixo e entraremos em contato",
    fullName: "Nome completo",
    fullNamePlaceholder: "Digite seu nome completo",
    emailAddress: "Endereço de e-mail",
    emailPlaceholder: "Digite seu endereço de e-mail",
    subject: "Assunto",
    subjectPlaceholder: "Sobre o que é?",
    message: "Mensagem",
    messagePlaceholder: "Conte-nos mais sobre sua solicitação...",
    sending: "Enviando...",
    sendMessage: "Enviar mensagem",
    successMessage: "Mensagem enviada com sucesso! Entraremos em contato em breve.",
    errorMessage: "Algo deu errado. Por favor, tente novamente.",
  },

  // Blog
  blog: {
    insightsStrategy: "Insights e estratégia",
    masterTheArt: "Domine a arte do",
    instagramGrowth: "Crescimento no Instagram",
    blogSubtitle: "Descubra guias de especialistas, segredos de automação e estratégias comprovadas para transformar seus comentários em clientes.",
    searchPlaceholder: "Buscar estratégias, guias...",
    followForUpdates: "Siga para novidades",
    latestStories: "Últimos artigos",
    minRead: "min de leitura",
    readStory: "Ler artigo",
    featuredStory: "Artigo em destaque",
    freshDrop: "Recém-publicado",
    readArticle: "Ler artigo",
    noArticlesFound: "Nenhum artigo encontrado",
    noArticlesDescription: "Não encontramos artigos correspondentes à sua busca. Tente ajustar seus filtros ou volte mais tarde.",
    clearSearch: "Limpar busca",
  },

  // Referral
  referral: {
    heading: "Participe do nosso programa de",
    headingHighlight: "Indicação",
    description: "Indique o Zapify para seus amigos e ganhe 20% da receita total que eles gastarem em uma assinatura paga durante o primeiro ano.",
    proSubscriber: "Assinante Zapify Pro",
    minimumDms: "ter enviado no mínimo 100 DMs",
    joinProgram: "Participar do programa de indicação",
    termsOfService: "termos de serviço.",
    step1: "Passo 1",
    step1Title: "Obtenha seu link de indicação",
    step1Desc: "Cadastre-se em minutos — sem aprovação necessária! Se você é assinante Pro com mais de 100 DMs enviados, já pode começar a ganhar.",
    referralLink: "Link de indicação",
    copy: "Copiar",
    step2: "Passo 2",
    step2Title: "Compartilhe e divulgue",
    step2Desc: "Copie seu link e compartilhe em qualquer lugar — Instagram, TikTok, YouTube, e-mail ou DMs. Quanto mais você compartilhar, mais vai ganhar!",
    step3: "Passo 3",
    step3Title: "Ganhe 20% de comissão",
    step3Desc: "Quando alguém assinar um plano pago usando seu link, você ganha 20% dos pagamentos durante o primeiro ano — pago mensalmente!",
    quickStats: "Estatísticas rápidas",
    clicks: "Cliques",
    converted: "Convertidos",
    total: "Total",
    pending: "Pendente",
    faqHeading: "Programa de indicação",
    faqSubheading: "As perguntas mais frequentes sobre nosso programa de indicação",
    faq1Q: "O que é o programa de indicação do Zapify?",
    faq1A: "O programa de indicação do Zapify permite que você ganhe comissões indicando novos usuários para nossa plataforma. Quando alguém assina um plano pago usando seu link exclusivo, você ganha 20% das taxas de assinatura durante o primeiro ano.",
    faq2Q: "Quem pode participar do programa de indicação?",
    faq2A: "Para participar, você precisa ser assinante Zapify Pro e ter enviado pelo menos 100 DMs usando nossas ferramentas de automação. Isso garante que nossos afiliados são usuários ativos que podem recomendar genuinamente a plataforma.",
    faq3Q: "Como e quando eu recebo o pagamento?",
    faq3A: "As comissões são pagas mensalmente via PayPal assim que seus ganhos atingirem o limite mínimo de $50. Os pagamentos são processados aproximadamente 30 dias após o final do mês em que foram gerados.",
    faq4Q: "Existe um limite para quanto posso ganhar?",
    faq4A: "Não! Não há teto para seus ganhos. Quanto mais indicações de sucesso você fizer, mais vai ganhar.",
  },

  // Tools Page
  toolsPage: {
    heading: "Ferramentas de Instagram",
    headingHighlight: "grátis",
    description:
      "Calculadoras, geradores, ferramentas de formatação e mais — tudo grátis, sem cadastro. Feito para criadores que querem crescer de forma inteligente.",
    searchPlaceholder: "Buscar ferramentas...",
    all: "Todas",
    noToolsFound: "Nenhuma ferramenta encontrada para sua busca.",
    free: "Grátis",
    comingSoon: "Em breve",
    relatedTools: "Ferramentas relacionadas",
    relatedToolsDesc: "Mais ferramentas grátis para fazer seu Instagram crescer",
    viewAllTools: "Ver todas as ferramentas grátis",
    frequentlyAsked: "Perguntas",
    questionsHighlight: "frequentes",
    faqDescription: "Tudo o que você precisa saber sobre",
  },

  // Use Case
  useCase: {
    heading: "O que você pode automatizar com o",
    headingHighlight: "Zapify?",
    description: "De impulsionar vendas a coletar e-mails — veja como criadores e marcas usam o Zapify para automatizar seus DMs do Instagram e crescer no piloto automático.",
    startForFree: "Comece grátis",
    learnMore: "Saiba mais",
    bottomCtaHeading: "Pronto para automatizar seus DMs do Instagram?",
    bottomCtaDesc: "Junte-se a milhares de criadores que usam o Zapify para transformar conversas em vendas — automaticamente.",
    freeToStart: "Grátis para começar · Configuração fácil",
  },

  footer: {
    description:
      "A ferramenta #1 de automação de DMs do Instagram, confiada por mais de 5.000 criadores em todo o mundo.",
    product: "Produto",
    company: "Empresa",
    compare: "Comparar",
    howItWorks: "Como funciona",
    termsOfService: "Termos de Serviço",
    privacyPolicy: "Política de Privacidade",
    refundPolicy: "Política de Reembolso",
    contactUs: "Fale Conosco",
    referralProgram: "Programa de Indicação",
    copyright: "Todos os direitos reservados.",
    builtWith: "Feito com \u2764\uFE0F para criadores",
    useCasesHeading: "Casos de Uso",
    allUseCases: "Todos os Casos de Uso",
    sendLinksInDms: "Enviar Links nos DMs",
    autoRespondComments: "Auto-Responder Comentários",
    collectEmails: "Coletar E-mails",
    storyReplies: "Respostas de Stories",
  },

  // Auth
  auth: {
    welcomeToZapify: "Bem-vindo ao Zapify",
    setItUpOnce: "Configure uma vez. Deixe a IA fazer o resto.",
    recommended: "Recomendado",
    continueWithInstagram: "Continuar com Instagram",
    continueWithGoogle: "Continuar com Google",
    redirecting: "Redirecionando...",
    orContinueWithEmail: "ou continue com e-mail",
    emailAddress: "Endereço de e-mail",
    emailRequired: "O e-mail é obrigatório",
    validEmail: "Por favor, insira um e-mail válido",
    sendingCode: "Enviando código...",
    startFree: "Começar grátis",
    enterVerificationCode: "Insira o código de verificação",
    weSentCode: "Enviamos um código de 6 dígitos para",
    otpRequired: "O código OTP é obrigatório",
    otpDigits: "O código OTP deve ter 6 dígitos",
    verifying: "Verificando...",
    verifyAndContinue: "Verificar e continuar",
    useDifferentEmail: "Usar outro e-mail",
    agreeToTerms: "Ao continuar, você concorda com nossos",
    termsOfService: "Termos de Serviço",
    and: "e",
    privacyPolicy: "Política de Privacidade",
    haveDiscountCode: "Tem um código de desconto?",
    discountCode: "Código de desconto",
    enterCode: "Insira o código",
    apply: "Aplicar",
    applied: "Aplicado",
    congratsDiscount: "Parabéns! Você ganhou 20% de desconto extra.",
    invalidCode: "Código de desconto inválido",
    redirectingToDashboard: "Redirecionando para o painel...",
    referralBannerText: "Parabéns! Você ganhou 20% de desconto extra.",
    extendedTrialBannerText: "Parabéns! Você desbloqueou {days} dias de teste gratuito.",
  },

  // Comparison
  comparison: {
    updatedDate: "Atualizado em março de 2026",
    startFreeNoCreditCard: "Comece grátis — Sem cartão de crédito",
    seeFullComparison: "Ver comparação completa",
    quickAnswer: "Resposta rápida",
    featureComparison: "Comparação recurso por recurso",
    samePriceTitle: "Mesmo preço, mas o que você realmente recebe?",
    aiVsKeywords: "Reconhecimento de intenção por IA vs modelos básicos de palavras-chave",
    userComments: "O que os usuários realmente digitam nos comentários:",
    bottomCtaHeading: "Pronto para experimentar a alternativa mais inteligente?",
    bottomCtaDesc: "Junte-se a milhares de criadores que mudaram para o Zapify pela automação de Instagram com IA.",
    getStarted: "Comece gratuitamente",
    freeToStart: "Grátis para começar · Sem cartão de crédito",
    feature: "Recurso",
    category: "Categoria",
    pricingTiers: "Níveis de preço",
    faq: "Perguntas frequentes",
  },

  // Legal
  legal: {
    lastUpdated: "Última atualização",
    haveQuestions: "Tem dúvidas?",
    contactEmail: "Fique à vontade para entrar em contato em",
    returnToWebsite: "Voltar ao site",
    termsOfService: "Termos de Serviço",
    privacyPolicy: "Política de Privacidade",
    refundPolicy: "Política de Reembolso",
    dataDeletion: "Política de exclusão de dados",
  },

  // Use Case Layout
  useCaseLayout: {
    startForFree: "Comece grátis",
    freeToStart: "Grátis para começar · Configuração fácil",
    frequentlyAsked: "Perguntas",
    questionsHighlight: "frequentes",
    readyToAutomate: "Pronto para automatizar seus DMs do Instagram?",
    readyToAutomateDesc: "Junte-se a milhares de criadores que usam o Zapify para transformar conversas em vendas — automaticamente.",
    trigger: "Gatilho:",
    response: "Resposta:",
    exploreMore: "Explorar mais",
  },
};

export default pt;
